var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-view',{staticClass:"max-height shopline"},[_c('div',{staticClass:"loading-spinner large m-a"})])
}
var staticRenderFns = []

export { render, staticRenderFns }